/** @jsx jsx */
import { css } from "@emotion/react";

export const footerSection = css`
  position: relative;
  padding: 80px 0;
  background: #33535E;
  font-family:"obviously-narrow";
  font-variation-settings: "wght" 700;
  p {
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: #EFEFEF;
  }


  /* styles.css ou equivalente */
@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.swiper-container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 40px;
}

.scrolling-text {
  font-size: 104px; /* Ajuste conforme necessário */
  font-weight: bold;
  color: #cbff3a; /* Verde neon como na imagem */
  text-transform: uppercase;
  letter-spacing: 2px;
  white-space: nowrap; /* Evita quebra de linha */
  font-family:"obviously-narrow";
  font-variation-settings: "wght" 700;
  margin-left: 100px;

  span{
    font-style:italic;
  }
}

.swiper-container .swiper-wrapper {
  transition-timing-function: linear;
}
  .swiper-slide {
    width: auto !important;
  }
  .swiper-slide-active{
    width: auto !important;
  }

  .containerFluid{
    padding-left: 47px;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    .containerFluid{
      padding-left: 15px;
  }
  }

`

export const footerContent = css`
  display: flex;
  flex-direction: column;
  h2 {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 19.2px */
    text-transform: uppercase;
    color: #EFEFEF;
    margin-bottom: 24px;
  }
  a {
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: #EFEFEF;
    :not(:last-child) {
      margin-bottom: 4px;
    }
    :hover {
      font-weight: bold;
      color: #EFEFEF;
    }
  }
`

export const copySection = css`
  margin-top: 8px;
`

export const socialIcons = css`
  display: flex;
  flex-direction: column;
  h3 {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 28.8px */
    text-transform: uppercase;
    color: #EFEFEF;
    margin-right: 16px;
    margin-bottom: 32px;
  }
  img {
    margin-right: 8px;
  }

  a{
    margin-top:6px;
    i{
      font-size: 24px;
      color: #C2F57E;
      margin-right: 16px;
    }
  }

  div{
    margin-bottom: 16px;
    p{
      margin-bottom: 8px;
    }
    a:first-of-type{
      margin-left: 16px;
    }
  }

  .socialMobile{
    div{
      a:first-of-type{
        margin-left: 0;
      }
    }
  }
`


export const unidadesSec = css`
  display: flex;
  flex-direction: column;
  
  h2 {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 19.2px */
    text-transform: uppercase;
    color: #EFEFEF;
    margin-bottom: 12px;
  }
  p {
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: #EFEFEF;
    :not(:last-child) {
      margin-bottom: 8px;
    }
    img {
      margin-right: 4px;
    }
    span, ivisual{
      color: #C2F57E;
    }
    a{
      color: #EFEFEF;
    }
  }
  @media (min-width: 320px) and (max-width: 767px) {
    text-align: center;
    p {
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      img {
        width: fit-content;
      }
      :not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }

  @media (min-width: 481px) and (max-width: 767px) {
    text-align: center;
    p {
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      img {
        width: fit-content;
      }
      :not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 990px) {
    text-align: center;
    p {
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      img {
        width: fit-content;
      }
      :not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }
`


export const footerInternaSection = css`
  position: relative;
  padding: 80px 0;
  background: #312F2D;
  font-family:"obviously-narrow";
  font-variation-settings: "wght" 700;
  p {
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: #EFEFEF;
  }


  /* styles.css ou equivalente */
@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.swiper-container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 40px;
}

.scrolling-text {
  font-size: 104px; /* Ajuste conforme necessário */
  font-weight: bold;
  color: #cbff3a; /* Verde neon como na imagem */
  text-transform: uppercase;
  letter-spacing: 2px;
  white-space: nowrap; /* Evita quebra de linha */
  font-family:"obviously-narrow";
  font-variation-settings: "wght" 700;
  margin-left: 100px;

  span{
    font-style:italic;
  }
}

.swiper-container .swiper-wrapper {
  transition-timing-function: linear;
}
  .swiper-slide {
    width: auto !important;
  }
  .swiper-slide-active{
    width: auto !important;
  }

  .containerFluid{
    padding-left: 47px;
  }

`

export const DDesktop = css` 
  @media (min-width: 320px) and (max-width: 767px) {
    display: none;
  }

  @media (min-width: 481px) and (max-width: 767px) {
    display: none;
  }

  @media (min-width: 768px) and (max-width: 990px) {
    display: none;
  }

  @media (min-width: 991px) and (max-width: 1199px) {
    display: flex;
  }

  @media (min-width: 1200px) and (max-width: 1600px) {
    display: flex;
  }
`

export const DMobile = css` 
  @media (min-width: 320px) and (max-width: 767px) {
    display: flex;
  }

  @media (min-width: 481px) and (max-width: 767px) {
    display: flex;
  }

  @media (min-width: 768px) and (max-width: 990px) {
    display: flex;
  }

  @media (min-width: 991px) and (max-width: 1199px) {
    display: none;
  }

  @media (min-width: 1200px) and (max-width: 3600px) {
    display: none;
  }
`

export const DMobileMenu = css` 
  @media (min-width: 320px) and (max-width: 767px) {
    div{
      width: auto;
    }
  }
`
export const paisMobile = css` 
  @media (min-width: 320px) and (max-width: 767px) {
    div{
      width: auto;
    }
  }
`
export const acompanheMobile = css` 
  @media (min-width: 320px) and (max-width: 767px) {
    justify-content: center;

    h3{
      text-align: center;
    }
  }
`
export const unidadesSecMobile = css` 
  @media (min-width: 320px) and (max-width: 767px) {
    i{
      display:block;
    font-size: 24px;   }
  }
`
